import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../common';
import { API_URL } from '../../../../services';
import { LoadIdView } from '../../../models';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { ShipmentLoadEndpoint } from '../constants';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadItemService {
  constructor(private http: WrapperHttpService) {}

  getShipmentLoadDemurrageAndDetentionTab(loadIdView: LoadIdView): Observable<boolean> {
    return this.http
      .withLoading()
      .get(
        `${API_URL}${ShipmentLoadEndpoint.Base}${ShipmentLoadEndpoint.Loads}${ShipmentLoadEndpoint.ContainerCharges}${
          ShipmentLoadEndpoint.Available
        }?${getQueryStringFromObject(loadIdView)}`,
      );
  }
}
